import { blue05 } from '../../../colors/blue';
export var MuiFormControl = {
    styleOverrides: {
        root: {
            "& [class*='MuiInputAdornment-root'] [class*='Mui-focusVisible']": {
                boxShadow: "0 0 0 2px ".concat(blue05),
            },
        },
    },
    customOverrides: {
        datePickerPristine: {
            '& [class*=Mui-error] [class*=MuiOutlinedInput-notchedOutline]': {
                borderColor: blue05,
            },
        },
    },
};
